module.exports = __webpack_public_path__ + "media/images/icons/upload-a5d3dd89f0f6d3a02bc939db4e73d792.svg";